{
  "FundingContractStatus": {
    "Draft": "Concept",
    "Canceled": "Geannuleerd",
    "SentManually": "Verstuurd",
    "SentDigital": "Verstuurd",
    "SignedByFunder": "Getekend",
    "Active": "Rentedragend",
    "Inactive": "Inactief",
    "Validated": "Gecontroleerd"
  },
  "FundingContractCancelReason": {
    "ErrorByPartner": "Fout door partner",
    "ErrorByFunder": "Fout door spaarder",
    "FunderCancelRequest": "Annuleringsverzoek spaarder",
    "Other": "Anders"
  },
  "FundingContractVariant": {
    "Protected": "Beschermd (A)",
    "Plus": "Plus (B)"
  },
  "LegalStructure": {
    "SoleProprietor": "Eenmanszaak",
    "GeneralOrCommercialPartnership": "Vennootschap onder firma (vof)",
    "LimitedPartnership": "Commanditaire vennootschap (cv)",
    "ProfessionalOrPublicPartnership": "Maatschap",
    "PrivateLimitedCompany": "Besloten vennootschap (bv)",
    "Association": "Vereniging",
    "Foundation": "Stichting",
    "PublicLimitedCompany": "Naamloze vennootschap (nv)",
    "Cooperative": "Coöperatieve vennootschap",
    "Other": "Overig"
  },
  "durationInMonths": {
    "3": "3 maanden",
    "6": "6 maanden",
    "12": "1 jaar",
    "24": "2 jaar",
    "36": "3 jaar",
    "unknown": "Anders ({time})"
  },
  "FunderType": {
    "Business": "Zakelijk",
    "Consumer": "Particulier"
  },
  "FileTypes": {
    "UnsignedContract": "Contract",
    "SignedContract": "Getekend contract",
    "ProofOfSigning": "Bewijs van ondertekening",
    "UnsignedPartnerCooperationAgreement": "Samenwerkingsovereenkomst",
    "SignedPartnerCooperationAgreement": "Getekende samenwerkingsovereenkomst",
    "ProofOfSigningPartnerCooperationAgreement": "Bewijs van ondertekening samenwerkingsovereenkomst",
    "ProofOfSigningFrameworkAgreementAndQuote": "Bewijs van ondertekening raamovereenkomst en offerte",
    "AnnualStatement": "Jaaroverzicht",
    "UnsignedQuote": "Offerte",
    "SignedQuote": "Getekende offerte",
    "UnsignedFrameworkAgreement": "Raamovereenkomst",
    "SignedFrameworkAgreement": "Getekende raamovereenkomst",
    "SepaContract": "Sepa contract",
    "UnsignedDeclarationOfSourceOfFunds": "Verklaring herkomst van middelen",
    "SignedDeclarationOfSourceOfFunds": "Getekende verklaring herkomst van middelen"
  },
  "FundingContractRenewalOptions": {
    "Renew": "Volledige verlenging",
    "RenewAndTopUp": "Verlenging met bijstorting",
    "PartiallyRenew": "Gedeeltelijke verlenging",
    "Expire": "Geen verlenging"
  },
  "FundingContractExpirationReason": {
    "InterestRateTooLow": "Rente te laag",
    "OtherInvestmentOptions": "Andere investeringsmogelijkheden",
    "MoneyNeededForOtherPurposes": "Geld nodig voor andere doeleinden",
    "Other": "Anders"
  },
  "FundingContractDeclinedReason": {
    "InterestRateTooLow": "Rente te laag",
    "OtherInvestmentOptions": "Andere investeringsmogelijkheden",
    "MoneyNeededForOtherPurposes": "Geld nodig voor andere doeleinden",
    "ContractTermsDoNotAlign": "Contractvoorwaarden komen niet overeen",
    "Other": "Anders"
  },
  "FundingContractActiveDissolveReason": {
    "PassedAway": "Overlijden",
    "Leniency": "Coulance",
    "Overfunding": "Overfunding",
    "KnowYourCustomer": "KYC / Wwft",
    "Other": "Anders"
  },
  "FundingContractSignedDissolveReason": {
    "DepositNotReceived": "Storting niet ontvangen",
    "KnowYourCustomer": "KYC / Wwft",
    "Other": "Anders"
  },
  "PartnerBusinessType": {
    "FinancialAdvisor": "Financieel adviseur",
    "Accountant": "Accountant",
    "AssetManager": "Vermogensbeheerder",
    "FamilyOffice": "Family office",
    "TaxAnalyst": "Fiscalist",
    "FinancialPlanner": "Financieel planner"
  },
  "PaymentType": {
    "Interest": "Rente",
    "Reimbursement": "Terugbetaling",
    "FinalPayment": "Eindafrekening",
    "PartnerFee": "Partnervergoeding"
  },
  "IdentityValidationMethod": {
    "Idin": "iDIN",
    "Manual": "Handmatig"
  },
  "Genders": {
    "M": "M",
    "V": "V",
    "X": "X"
  },
  "Granularity": {
    "Daily": "Dagelijks",
    "Weekly": "Wekelijks",
    "Monthly": "Maandelijks",
    "Yearly": "Jaarlijks"
  },
  "PartnerFeeGroup": {
    "None": "Geen fee",
    "Bronze": "Brons",
    "Silver": "Zilver",
    "Gold": "Goud"
  },
  "PartnerType": {
    "SMEFinance": "Financieringspartner",
    "Funding": "Spaarpartner"
  },
  "FinanceReceiverStatus": {
    "PreScanSubmitted": "Pre-Scan ingediend",
    "PreScanInProgress": "Pre-Scan in behandeling",
    "PreScanRejected": "Pre-Scan afgewezen",
    "PreScanWithdrawn": "Pre-Scan ingetrokken",
    "Inactive": "Niet lenende klant",
    "Active": "Actief lenende klant",
    "Delinquent": "Klant in bijzonder beheer",
    "Defaulting": "Klant in gebreke",
    "Offboarded": "Klant-af"
  },
  "FinanceReceiverFacility": {
    "RevolvingCredit": "Rekening Courant",
    "RealEstate": "Vastgoed"
  },
  "LoanStatus": {
    "Requested": "Aangevraagd",
    "Approved": "Goedgekeurd",
    "ApprovedRenewal": "In afwachting van start",
    "ApprovedAndPaid": "Goedgekeurd en uitbetaald",
    "Rejected": "Afgewezen",
    "Completed": "Afgehandeld en terugbetaald",
    "CompletedAndRefunded": "Afgehandeld en terugbetaald",
    "Defaulting": "In gebreke",
    "Irrecoverable": "Oninbaar",
    "DirectDebitProcessing": "Betaling in behandeling",
    "DirectDebitsProcessing": "Betalingen in behandeling"
  },
  "CompanyStatus": {
    "Active": "Actief",
    "NonActive": "Inactief",
    "Pending": "In afwachting",
    "Liquidated": "Geliquideerd",
    "Dormant": "Geen activiteiten",
    "Dissolved": "Ontbonden",
    "InAdministration": "Onder curatele",
    "InReceivership": "Onder bewind",
    "InLiquidation": "In liquidatie",
    "ProposalToStrikeOff": "Voorstel tot uitschrijving",
    "StrikeOffListed": "Geregistreerd voor uitschrijving",
    "Other": "Overig"
  },
  "DirectDebitStatus": {
    "Scheduled": "Ingepland",
    "Successful": "Betaald",
    "Failed": "Mislukt",
    "Cancelled": "Geannuleerd",
    "Processing": "Betaling in behandeling"
  },
  "LoanProcessorStateReason": {
    "DataNotUpToDate": "Gegevens niet actueel",
    "PaymentObligationNotMet": "Betalingsverplichting niet nagekomen",
    "Other": "Overig"
  },
  "ContractType": {
    "Quote": "Offerte",
    "FrameworkAgreement": "Raamovereenkomst"
  },
  "CollateralType": {
    "FirstPledgeGroupAssets": "1e pandrecht activa op groepsniveau",
    "FirstPledgeClientAssets": "1e pandrecht activa op klantniveau",
    "PersonalGuarantee": "Privé borgstelling",
    "ThirdPartyPersonalGuarantee": "Privé borgstelling derden",
    "BusinessGuarantee": "Borgstelling zakelijk",
    "ThirdPartyBusinessGuarantee": "Borgstelling zakelijk derden",
    "MortgageDeclaration": "Positieve/negatieve hypotheekverklaring",
    "FirstMortgageRight": "1e recht van hypotheek",
    "SecondMortgageRight": "2e recht van hypotheek",
    "JointLiabilityByEntityForm": "Hoofdelijk aansprakelijk vanuit rechtsvorm",
    "RefinancingChecklistOnly": "Herfinanciering",
    "Refinancing": "Herfinanciering"
  },
  "PaymentStatus": {
    "Prepared": "Voorbereid",
    "InProgress": "In behandeling",
    "Expired": "Verlopen",
    "Cancelled": "Geannuleerd",
    "Failed": "Mislukt",
    "Completed": "Afgerond"
  },
  "MessageGroupType": {
    "LoanCollectionUpcomingFirstAlert": "Eerste incasso attendering",
    "LoanCollectionDateWithinTwoDaysRenewalRequested": "Incasso attendering",
    "LoanCollectionDateWithinEightDays": "Incasso attendering",
    "LoanCollectionDateWithinTwoDays": "Incasso attendering",
    "LoanPaid": "Lening uitbetaald",
    "LoanRenewalRequestAccepted": "Lening verlengen goedgekeurd",
    "LoanEarlyRepaymentRequested": "Lening eerder terugbetalen",
    "LoanRejected": "Lening afgewezen",
    "FinanceReceiverFacilityActivated": "Welkomst bericht",
    "FinanceReceiverPsdAuthorizationTomorrowReminder": "Herinnering PSD autorisatie",
    "FinanceReceiverPsdAuthorizationInTwoWeeksReminder": "Herinnering PSD autorisatie",
    "PaymentReminder": "Herinnering",
    "LoanPaymentReminder": "Herinnering",
    "LoanPaymentReminderWithLegacyCosts": "Herinnering",
    "SystemMessage": "Systeembericht",
    "CreditLimitRequestConnectMissingBankAccounts": "Verbinding maken met ontbrekende bankrekeningen",
    "ConnectMissingBankAccounts": "Verbinding maken met ontbrekende bankrekeningen"
  },
  "CommunicationChannel": {
    "Email": "E-mail",
    "Message": "Berichtenbox bericht"
  },
  "NoteType": {
    "Email": "Via e-mail",
    "Phone": "Per telefoon",
    "Other": "Overig",
    "InPerson": "Persoonlijk"
  },
  "CollateralRenewalOptions": {
    "Maintain": "Handhaven",
    "Renew": "Vernieuwen",
    "Expire": "Vervalt"
  },
  "FinanceReceiverFileTypes": {
    "SepaContract": "Sepa contract",
    "Quote": "Offerte rekening Courant",
    "RealEstateQuote": "Offerte vastgoed",
    "FrameworkAgreement": "Raamovereenkomst"
  },
  "FunderFileTypes": {
    "AnnualStatement": "Jaaroverzicht",
    "DeclarationOfSourceOfFunds": "Verklaring herkomst van middelen"
  },
  "CollateralExpirationReasons": {
    "CreditLimitUpdate": "Vervangen wegens faciliteitswijziging"
  },
  "CreditLimitDisabledReason": {
    "Defaulting": "De klant is in gebreke.",
    "ExpiredPsdAuthorization": "De klant heeft een verlopen PSD verbinding.",
    "NoConnectedSepa": "De klant mist een PSD verbinding voor de bankrekening van een van de SEPA contracten.",
    "CreditLimitRequest": "De klant heeft een kredietlimiet aanvraag ingediend.",
    "Disabled": "Het kredietlimiet is handmatig geblokkeerd.",
    "Onboarding": "De klant is nog bezig met het onboarding proces.",
    "Offboarded": "De klant is klant-af.",
    "Migrating": "De klant is geblokkeerd tot de migratie naar v2 is afgerond."
  },
   "FundSourceType": {
    "Turnover": "Winst",
    "Loan": "Lening",
    "Donation": "Schenking",
    "Other": "Anders"
  },
  "CompanySearchCountries": {
    "NL": "NL",
    "BE": "BE"
  },
  "RealEstatePaymentStatus": {
    "Expected": "Verwacht",
    "Completed": "Betaald",
    "Default": "In gebreke"
  }
}
